<template>
  <section class="section partners-section">
    <div class="section-inner">
      <div class="partners-head">
        <h2 class="section-title">合作伙伴</h2>
        <p class="section-subtitle">与不同行业企业深度合作，共建开放共赢生态。</p>
      </div>
      <div class="partners-strip">
        <button
          v-for="item in partners"
          :key="item.id"
          type="button"
          class="partner-chip"
          @click="openLink(item.link)"
        >
          <img :src="item.logo" :alt="item.name">
          <span>{{ item.name }}</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PartnerLogos',
  computed: {
    partners() {
      return this.$store.getters.getPartnersList
    }
  },
  methods: {
    openLink(link) {
      if (!link) return
      window.open(link, '_blank')
    }
  }
}
</script>

<style scoped>
.partners-section {
  background: #ffffff;
  border-top: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
}

.partners-head {
  margin-bottom: 28px;
}

.partners-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.partner-chip {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  padding: 14px 22px;
  border: 1px solid #dbe4f0;
  background: #f8fbff;
  color: #1e293b;
  cursor: pointer;
  border-radius: 999px;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1.3;
  transition: border-color 0.18s ease, background-color 0.18s ease;
}

.partner-chip img {
  width: 72px;
  height: 48px;
  object-fit: cover;
  border-radius: 8px;
  background: #fff;
  flex-shrink: 0;
}

.partner-chip:hover {
  border-color: #7dd3fc;
  background: #e0f2fe;
}

@media (max-width: 768px) {
  .partner-chip {
    font-size: 15px;
    padding: 12px 16px;
    gap: 12px;
  }

  .partner-chip img {
    width: 56px;
    height: 38px;
  }
}
</style>
